import * as hangul from 'hangul-js';

export default {
  install: (Vue) => {
    Vue.hangul = hangul;
    Vue.prototype.hangul = hangul;
  },
};
